import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import { initializeAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { AuthAdapter } from "./auth.adapter.js";
class FirebaseAdapter {
  static init(appConfig, authConfig) {
    let instances = {};
    if (authConfig) {
      const { name: name2 = "[AUTH]", ...config2 } = authConfig;
      const authApp = initializeApp(config2, name2);
      initializeFirestore(authApp, { experimentalAutoDetectLongPolling: true });
      instances = {
        authApp,
        authAdapter: new AuthAdapter(getAuth(authApp))
      };
    }
    const { name = "[DEFAULT]", ...config } = appConfig;
    const defaultApp = initializeApp(config, name);
    initializeFirestore(defaultApp, { experimentalAutoDetectLongPolling: true });
    initializeAnalytics(defaultApp);
    return {
      ...instances,
      defaultApp
    };
  }
}
export {
  FirebaseAdapter
};
//# sourceMappingURL=firebase.adapter.js.map
